export default __webpack_public_path__ + "static/media/mercedes-v8.04273245.png";